import styled from '@emotion/styled';

export const RegularTextWrapper = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.palette?.brand.secondary.base}
`;
